import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { getViewingProfileTitle } from '../../RentalPortalViewingProfile.utils'
import { RentalPortalViewingProfileDocumentUploadModal } from '../../RentalPortalViewingProfileDocumentUploadModal'
import { useViewingProfileContext } from '../useViewingProfileContext'

export function useViewingDocumentUpload() {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { handleCloseModal, handleReloadDocuments, setModal, viewingData } =
    useViewingProfileContext()

  function handleOpenDocumentUpload() {
    setModal(
      <RentalPortalViewingProfileDocumentUploadModal
        title={getViewingProfileTitle({ locale, t, timezone, viewingData })}
        viewingId={viewingData.id}
        onClose={handleCloseModal}
        onUploaded={handleReloadDocuments}
      />
    )
  }

  return { handleOpenDocumentUpload }
}
